import $global from 'stores/global'

export const INTEGRATIONS_META = {
  linkedin: {
    name: 'LinkedIn',
    logo: 'assets/linkedin.svg',
    description: 'Personalized outreach with social updates.',
    type: 'linkedin'
  },
  google_calendar: {
    name: 'Google Calendar',
    logo: 'assets/google-calendar.svg',
    description: 'Synchronizing events from your calendar.',
    type: 'google_calendar'
  },
  ms_calendar: {
    name: 'Microsoft Outlook Calendar',
    logo: 'assets/ms-calendar.svg',
    description: 'Synchronizing events from your calendar.',
    type: 'ms_calendar'
  },
  salesforce: {
    name: 'Salesforce',
    logo: 'assets/salesforce.svg',
    description: 'Synchronizing accounts and contacts from your salesforce.',
    type: 'salesforce'
  }
}

export function getIntegrations() {
  const result = [
    {
      name: INTEGRATIONS_META.linkedin.name,
      logo: INTEGRATIONS_META.linkedin.logo,
      type: INTEGRATIONS_META.linkedin.type,
      description: INTEGRATIONS_META.linkedin.description,
      connected: false,
      store: undefined,
      disabled: false
    }
  ]

  if ($global.gCalendarEnabled) {
    result.push({
      name: INTEGRATIONS_META.google_calendar.name,
      logo: INTEGRATIONS_META.google_calendar.logo,
      type: INTEGRATIONS_META.google_calendar.type,
      description: INTEGRATIONS_META.google_calendar.description,
      connected: false,
      store: undefined
    })
  }

  if ($global.msCalendarEnabled) {
    result.push({
      name: INTEGRATIONS_META.ms_calendar.name,
      logo: INTEGRATIONS_META.ms_calendar.logo,
      type: INTEGRATIONS_META.ms_calendar.type,
      description: INTEGRATIONS_META.ms_calendar.description,
      connected: false,
      store: undefined
    })
  }

  if ($global.salesforceEnabled) {
    result.push({
      name: INTEGRATIONS_META.salesforce.name,
      logo: INTEGRATIONS_META.salesforce.logo,
      description: INTEGRATIONS_META.salesforce.description,
      type: INTEGRATIONS_META.salesforce.type,
      connected: false,
      store: undefined
    })
  }

  // Will be uncommented in the future, do not delete
  // {
  //   name: 'Google Mail',
  //   logo: 'assets/google-mail.svg',
  //   description: 'Synchronizing emails from your Google Mail.',
  //   connected: false,
  //   type: 'google_mail',
  //   store: undefined,
  //   disabled: true
  // },
  // {
  //   name: 'Google Drive',
  //   logo: 'assets/google-drive.svg',
  //   description: 'Synchronizing files from your Google Drive.',
  //   connected: false,
  //   type: 'google_drive',
  //   store: undefined,
  //   disabled: true
  // },
 
  return result
}

export function getIntegrationTypes() {
  return getIntegrations().map(integration => integration.type)
}
